// extracted by mini-css-extract-plugin
module.exports = {"menuItemDisabled":"MenuItem_menuItemDisabled__1eAhF","menuItem":"MenuItem_menuItem__M5zV1","tooltip":"MenuItem_tooltip__6EJBu"};